import React from "react";
import { t } from "../../../../../../../utils/i18n";

const AllPaymentMethods = ({
  allPaymentMethods,
  giftCards,
  onlineTransfers,
  cashDeposits,
  creditCards,
  bankTransfers,
  digitalCurrencies,
  goodsAndServices,
  onSelectPaymentMethodGroup
}) => {
  return (
    <div className="payment-methods">
      <button
        className="btn btn-light"
        onClick={e => onSelectPaymentMethodGroup(e, "all-payment-methods")}
      >
        <span className="name">{t("p2p.payment_methods.all")}</span>
        <span className="count">
          {allPaymentMethods.length}
          <i className="fa fa-arrow-right" aria-hidden="true"></i>
        </span>
      </button>
      <button
        className="btn btn-light"
        onClick={e => onSelectPaymentMethodGroup(e, "bank-transfers")}
      >
        <span className="name">{t("p2p.payment_methods.bank")}</span>
        <span className="count">
          {bankTransfers.length}
          <i className="fa fa-arrow-right" aria-hidden="true"></i>
        </span>
      </button>
      <button
        className="btn btn-light"
        onClick={e => onSelectPaymentMethodGroup(e, "online-transfers")}
      >
        <span className="name">{t("p2p.payment_methods.online")}</span>
        <span className="count">
          {onlineTransfers.length}
          <i className="fa fa-arrow-right" aria-hidden="true"></i>
        </span>
      </button>
      <button
        className="btn btn-light"
        onClick={e => onSelectPaymentMethodGroup(e, "debitcredit-cards")}
      >
        <span className="name">{t("p2p.payment_methods.cards")}</span>
        <span className="count">
          {creditCards.length}
          <i className="fa fa-arrow-right" aria-hidden="true"></i>
        </span>
      </button>
      <button
        className="btn btn-light"
        onClick={e => onSelectPaymentMethodGroup(e, "gift-cards")}
      >
        <span className="name">{t("p2p.payment_methods.gift")}</span>
        <span className="count">
          {giftCards.length}
          <i className="fa fa-arrow-right" aria-hidden="true"></i>
        </span>
      </button>
      <button
        className="btn btn-light"
        onClick={e => onSelectPaymentMethodGroup(e, "digital-currencies")}
      >
        <span className="name">{t("p2p.payment_methods.digital")}</span>
        <span className="count">
          {digitalCurrencies.length}
          <i className="fa fa-arrow-right" aria-hidden="true"></i>
        </span>
      </button>
      <button
        className="btn btn-light"
        onClick={e => onSelectPaymentMethodGroup(e, "cash-deposits")}
      >
        <span className="name">{t("p2p.payment_methods.cash")}</span>
        <span className="count">
          {cashDeposits.length}
          <i className="fa fa-arrow-right" aria-hidden="true"></i>
        </span>
      </button>
      <button
        className="btn btn-light"
        onClick={e => onSelectPaymentMethodGroup(e, "goods-and-services")}
      >
        <span className="name">{t("p2p.payment_methods.goods")}</span>
        <span className="count">
          {goodsAndServices.length}
          <i className="fa fa-arrow-right" aria-hidden="true"></i>
        </span>
      </button>
    </div>
  );
};

export default AllPaymentMethods;
